import React from 'react';

const ResponsiveGridCard = ({ 
  children, 
  title,
  className = '',
  colSizes = {
    xs: 12,
    sm: 6,
    md: 4,
    lg: 3,
    xl: 2
  }
}) => {
  const colClasses = [
    `col-${colSizes.xs}`,
    colSizes.sm && `col-sm-${colSizes.sm}`,
    colSizes.md && `col-md-${colSizes.md}`,
    colSizes.lg && `col-lg-${colSizes.lg}`,
    colSizes.xl && `col-xl-${colSizes.xl}`
  ].filter(Boolean).join(' ');

  return (
    <div className={`${colClasses} mb-3 ${className}`}>
      <div className="h-100">
        {title && <h6 className="mb-2">{title}</h6>}
        {children}
      </div>
    </div>
  );
};

export default ResponsiveGridCard;
